import { render, staticRenderFns } from "./EditSpace.vue?vue&type=template&id=3265cb04&scoped=true"
import script from "./EditSpace.vue?vue&type=script&lang=js"
export * from "./EditSpace.vue?vue&type=script&lang=js"
import style0 from "./EditSpace.vue?vue&type=style&index=0&id=3265cb04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3265cb04",
  null
  
)

export default component.exports